module.exports = __webpack_public_path__ + "static/media/upload.e4e5ca32.svg";